import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allEntidadesAction,
  setActivoEntidadesAction,
} from './EntidadesAction';
import FormEntidades from './components/FormEntidades';
import ListadoEntidades from './components/ListadoEntidades';

const EntidadesView = () => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={12}>
        <BotonComponent
          click={async () => {
            await setActivoEntidadesAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          mr={2}
          addIcon
        />
        <BotonComponent
          click={async () => {
            await setActivoEntidadesAction(dispatch, null);
            await allEntidadesAction(dispatch, {
              ...entidadesStore.params,
              idEntidad: null,
            });
          }}
          disabled={
            entidadesStore.all.length === 0 || entidadesStore.loadingAll
          }
          white
          refreshIcon
          text={entidadesStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <ListadoEntidades setOpenModalForm={setOpenModalForm} />
      </Grid>
      <ModalComponent
        id="modalFormEntidades"
        title={`${entidadesStore.activo ? 'Editar' : 'Nueva'} entidad`}
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormEntidades
          activo={entidadesStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default EntidadesView;
